/* eslint-disable no-unsafe-optional-chaining */
import React from "react";
import dayjs from "dayjs";
import ViewDetailsIcon from "../../../Common/Svgs/ViewDetailsIcon";
import EditIcon from "../../../Common/Svgs/EditIcon";
import TrashIcon from "../../../Common/Svgs/TrashIcon";
import ListDropdown from "../phase3/ListDropdown";
import QRCodeIcon from "../../../Common/Svgs/QRCodeIcon";
import SubmittedDetails from "../../../Core/Components/SubmittedDetails";
import DriverSuspendIcon from "../../../Common/Svgs/DriverSuspendIcon";
import DriverResumeIcon from "../../../Common/Svgs/DriverResumeIcon";
// import { getPaymentDetailStatus } from "../../Revenue/getPaymentStatus";s
import {
  DriverCurrentTrike,
  LicenseValidityColumn,
} from "../phase3/Driver/DriverCustomColumns";
import { PartnerTag } from "../phase3/Partner/Tags";
import { formatPhoneNumber } from "../../../Utils/phoneNumberHelper";

export const usersColumns = [
  {
    title: () => (
      <div className="font-normal font-aileron text-10 text-dark-gray">
        Name
      </div>
    ),
    dataIndex: "id",
    sorter: (a, b) => a.firstName.localeCompare(b.firstName),
    render: (text, record) => (
      <div>
        <p className="text-xs font-semibold font-aileron leading-4.5 text-black capitalize">
          {record.firstName.trim()} {record.lastName.trim()}
        </p>

        {record.isSuspended ? (
          <p className="text-alert-red text-10 font-aileron font-normal">
            Suspended
          </p>
        ) : null}
        {record.isActive === 2 && record.email ? (
          <p className="text-alert-red text-10 font-aileron font-normal">
            {dayjs().diff(dayjs(record.signupCreatedAt), "hour") < 24
              ? "Signup Pending"
              : "Invitation Expired"}
          </p>
        ) : null}
      </div>
    ),
  },
  {
    title: () => (
      <div className="font-normal font-aileron text-10 text-dark-gray">
        Hub Station
      </div>
    ),
    dataIndex: "hubName",
    sorter: (a, b) => a?.hubName.localeCompare(b?.hubName),
    render: (text) => (
      <div className="text-xs font-semibold font-aileron leading-4.5 text-dark-grey-text capitalize">
        {text || "--"}
      </div>
    ),
  },
  {
    title: () => (
      <div className="font-normal font-aileron text-10 text-dark-gray">
        License ID
      </div>
    ),
    dataIndex: "licenseId",
    render: (text) => (
      <div className="text-xs font-semibold font-aileron leading-4.5 text-dark-grey-text">
        {text || "--"}
      </div>
    ),
  },
  {
    title: () => (
      <div className="font-normal font-aileron text-10 text-dark-gray">
        License Validity
      </div>
    ),
    dataIndex: "licenseValidity",
    sorter: (a, b) => a?.licenseValidity?.localeCompare(b?.licenseValidity),
    render: (text, record) => <LicenseValidityColumn record={record} />,
  },
  {
    title: () => (
      <div className="font-normal font-aileron text-10 text-dark-gray">
        Current Trike
      </div>
    ),
    dataIndex: "currentTrike",
    render: (text, record) => (
      <div className="max-w-max">
        <DriverCurrentTrike detail={record} />
      </div>
    ),
  },

  {
    title: () => (
      <div className="font-normal font-aileron text-10 text-dark-gray">
        No. of Trips
      </div>
    ),
    dataIndex: "trips",
    sorter: (a, b) => a?.trips - b?.trips,
    render: (text) => (
      <div className="text-xs font-semibold font-aileron leading-4.5 text-dark-grey-text">
        {text || "--"}
      </div>
    ),
  },
  // {
  //   title: () => (
  //     <div className="font-normal font-aileron text-10 text-dark-gray">
  //       Commission Status
  //     </div>
  //   ),
  //   dataIndex: "paymentStatus",
  //   render: (text) => (
  //     <div>{text === 0 ? "--" : getPaymentDetailStatus(text)}</div>
  //   ),
  // },

  {
    title: () => (
      <div className="font-normal font-aileron text-10 text-dark-gray">
        Date of Entry
      </div>
    ),
    dataIndex: "submittedBy",
    sorter: (a, b) => a?.submittedAt?.localeCompare(b?.submittedAt),
    render: (text, record) => <SubmittedDetails record={record} />,
  },
  {
    dataIndex: "id",
    width: "100px",
    render: (text, record) => (
      <button
        type="button"
        onClick={(event) => {
          event.stopPropagation();
        }}
        className="invisible group-hover:visible w-full flex items-center justify-center"
      >
        <ListDropdown detail={record} type="driver" />
      </button>
    ),
  },
];
export const farmersColumns = [
  {
    title: () => (
      <div className="font-normal font-aileron text-10 text-dark-gray">
        Partner
      </div>
    ),
    dataIndex: "firstName",
    // width: "150px",
    sorter: (a, b) => a?.firstName.localeCompare(b?.firstName),
    render: (text, record) => (
      <div>
        <p className="text-xs font-semibold font-aileron leading-4.5 capitalize">
          {record.firstName.trim()} {record.lastName.trim()}
        </p>

        {+record.isApproved === 0 && (
          <p className="text-10 font-semibold font-aileron leading-4.5 capitalize text-alert-red whitespace-nowrap">
            Approval Pending
          </p>
        )}
      </div>
    ),
  },

  {
    title: () => (
      <div className="font-normal font-aileron text-10 text-dark-gray">
        Unique ID
      </div>
    ),
    dataIndex: "uniqueId",
    render: (text) => (
      <div className="text-xs font-medium font-aileron leading-4.5 text-dark-grey-text">
        {text || "--"}
      </div>
    ),
  },
  {
    title: () => (
      <div className="font-normal font-aileron text-10 text-dark-gray">
        Contact Number
      </div>
    ),
    dataIndex: "contactNo",
    render: (text) => (
      <div className="text-xs font-medium font-aileron leading-4.5 text-dark-grey-text">
        {formatPhoneNumber(text)}
      </div>
    ),
  },
  {
    title: () => (
      <div className="font-normal font-aileron text-10 text-dark-gray">
        Type
      </div>
    ),
    dataIndex: "role",
    // width: "150px",
    render: (text) => <PartnerTag role={text} />,
  },
  {
    title: () => (
      <div className="font-normal font-aileron text-10 text-dark-gray">
        Hub Station
      </div>
    ),
    dataIndex: "hubName",
    sorter: (a, b) => a?.hubName?.localeCompare(b?.hubName),
    // width: "160px",
    render: (text) => (
      <div className="text-xs font-medium font-aileron leading-4.5 text-dark-grey-text capitalize">
        {text || "--"}
      </div>
    ),
  },
  {
    title: () => (
      <div className="font-normal font-aileron text-10 text-dark-gray">
        Collection Point
      </div>
    ),
    dataIndex: "locationName",
    // width: "150px",
    render: (text) => (
      <div className="text-xs font-medium font-aileron leading-4.5 text-dark-grey-text">
        {text || "--"}
      </div>
    ),
  },

  // {
  //   title: () => (
  //     <div className="font-normal font-aileron text-10 text-dark-gray">
  //       Total Weight Collected
  //     </div>
  //   ),
  //   dataIndex: "totalWeightCollected",
  //   sorter: (a, b) => a?.totalWeightCollected - b?.totalWeightCollected,
  //   render: (text) => (
  //     <div className="text-xs font-semibold font-aileron leading-4.5 text-dark-grey-text">
  //       {text ? `${text} Kg` : "--"}
  //     </div>
  //   ),
  // },
  // {
  //   title: () => (
  //     <div className="font-normal font-aileron text-10 text-dark-gray">
  //       Total Weight Delivered
  //     </div>
  //   ),
  //   dataIndex: "totalWeightDelivered",
  //   sorter: (a, b) => a?.totalWeightDelivered - b?.totalWeightDelivered,
  //   render: (text) => (
  //     <div className="text-xs font-semibold font-aileron leading-4.5 text-dark-grey-text">
  //       {text ? `${text} Kg` : "--"}
  //     </div>
  //   ),
  // },
  // {
  //   title: () => (
  //     <div className="font-normal font-aileron text-10 text-dark-gray">
  //       Payment Status
  //     </div>
  //   ),
  //   dataIndex: "role",
  //   sorter: (a, b) => a?.paymentStatus - b?.paymentStatus,
  //   width: "160px",
  //   render: (text, record) => <PaymentStatus detail={record} />,
  // },
  {
    title: () => (
      <div className="font-normal font-aileron text-10 text-dark-gray">
        Date of Entry
      </div>
    ),
    dataIndex: "submittedBy",
    sorter: (a, b) => a?.submittedAt?.localeCompare(b?.submittedAt),
    render: (text, record) => (
      <SubmittedDetails record={record} className="whitespace-nowrap" />
    ),
  },
  {
    dataIndex: "id",
    width: "120px",
    render: (text, record) => (
      <button
        type="button"
        onClick={(event) => {
          event.stopPropagation();
        }}
        className="invisible group-hover:visible w-full flex items-center justify-center"
      >
        <ListDropdown detail={record} type="farmer" />
      </button>
    ),
  },
];

export const usersDropdownBtnArr = [
  {
    title: "User Category",
    renderBody: "User Category",
    size: "filter",
    color: "white",
    padding: "filter",
    filters: "category",
  },

  {
    title: "Current Trike",
    renderBody: "Current Trike",
    size: "filter",
    color: "white",
    padding: "filter",
    filters: "trike",
  },
];

export const userDetailsColumn = [
  {
    title: () => (
      <div className="font-normal font-poppins text-10 leading-3.75 text-dark-grey-text">
        Date
      </div>
    ),
    dataIndex: "startDate",
    sorter: (a, b) => a.startDate.localeCompare(b.startDate),
    render: (text) => (
      <div className="text-xs font-medium font-poppins leading-4.5 text-dark-grey-text">
        {dayjs(text).format("DD-MM-YYYY")}
      </div>
    ),
  },
  {
    title: () => (
      <div className="font-normal font-poppins text-10 leading-3.75 text-dark-grey-text">
        Trike
      </div>
    ),
    dataIndex: "trikeRegistrationNo",
    render: (text) => (
      <div className="text-xs text-ellipsis whitespace-nowrap font-medium font-poppins leading-4.5 text-dark-grey-text">
        {text}
      </div>
    ),
  },
  {
    title: () => (
      <div className="font-normal font-poppins text-10 leading-3.75 text-dark-grey-text">
        Avg. Speed
      </div>
    ),
    dataIndex: "averageSpeed",
    sorter: (a, b) => a.averageSpeed - b.averageSpeed,
    render: (text) => (
      <div className="text-xs font-medium font-poppins leading-4.5 text-dark-grey-text">
        {text || "--"}
      </div>
    ),
  },
  {
    title: () => (
      <div className="font-normal font-poppins text-10 leading-3.75 text-dark-grey-text">
        Distance
      </div>
    ),
    dataIndex: "distance",
    sorter: (a, b) => a.distance - b.distance,
    render: (text) => {
      const distance = text ? `${parseFloat(text).toFixed(2)} Km` : "--";

      return (
        <div className="text-xs font-medium font-poppins leading-4.5 text-dark-grey-text">
          {distance}
        </div>
      );
    },
  },
];

export const threeDotsForDrivers = [
  {
    id: 1,
    value: "View Trip Details",
    icon: <ViewDetailsIcon className="text-dark-gray group-hover:text-black" />,
  },
  {
    id: 2,
    value: "Edit Details",
    icon: <EditIcon className="text-dark-gray group-hover:text-black" />,
  },
  {
    id: 4,
    value: "Suspend",
    icon: (
      <DriverSuspendIcon className="text-dark-gray group-hover:text-black" />
    ),
  },
  {
    id: 5,
    value: "Resume",
    icon: (
      <DriverResumeIcon className="text-dark-gray group-hover:text-black" />
    ),
  },
  {
    id: 3,
    value: "Delete User",
    icon: <TrashIcon className="text-alert-red" />,
  },
];

export const threeDotsForFarmers = [
  {
    id: 1,
    value: "Edit Details",
    icon: <EditIcon className="text-dark-gray group-hover:text-black" />,
  },
  {
    id: 2,
    value: "View QR Code",
    icon: <QRCodeIcon className="text-dark-gray group-hover:text-black" />,
  },
  {
    id: 3,
    value: "Delete User",
    icon: <TrashIcon className="text-alert-red" />,
  },
];
